export default __webpack_public_path__ + "static/media/vbb-3.c6408b9e.jpg";